import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy'
})
export class SortByPipe implements PipeTransform {

  transform(value: any[], property: string): any[] {
    if (!Array.isArray(value) || !property) return value;

    return [...value].sort((a, b) => {
      const propA = a[property]?.toString().toLowerCase() || '';
      const propB = b[property]?.toString().toLowerCase() || '';
      return propA.localeCompare(propB);
    });
  }

}
